import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JobAction } from 'modules/jobManager/types';

export const initialJobTableSearchState = '';

export const jobTableSearchReducer = (state = initialJobTableSearchState, action?: JobAction) => {
  switch (action?.type) {
    case ActionTypes.SET_TABLE_SEARCH: {
      return action?.payload ?? state;
    }

    default:
      return state;
  }
};
